import { BlockText, Separator, SideBox } from "@nju/ui";
import { formatPrice } from "@nju/utils";
import { SidebarRoamingOfferBenefits } from "./SidebarRoamingOfferBenefits";

type ISidebarRoamingOfferProps = {
  voicePackageAnniversaryDate: number | undefined;
  dataPackageAnniversaryDate: number | undefined;
  productOfferPrice: number;
  testId?: string;
};

export function SidebarRoamingOffer({
  voicePackageAnniversaryDate,
  dataPackageAnniversaryDate,
  productOfferPrice,
  testId,
}: ISidebarRoamingOfferProps) {
  return (
    <SideBox isExpandable={false} testId={testId} title="pakiet roamingowy">
      <BlockText className="my-4" size="keySM" weight="bold">
        {productOfferPrice && formatPrice(productOfferPrice)}
        <span className="text-size-16 font-normal"> zł</span>
      </BlockText>
      <Separator size="s" thickness="medium" tone="accent" />
      <SidebarRoamingOfferBenefits
        dataPackageAnniversaryDate={dataPackageAnniversaryDate}
        voicePackageAnniversaryDate={voicePackageAnniversaryDate}
      />
    </SideBox>
  );
}
